export default {
    alerts: {
        title: 'Alerts Settings',
        badges: 'Badges',
        tooltips: 'Tooltips',
    },
    chatFontColor: {
        current: 'Current',
        title: 'Chat Font Color',
        listTitle: 'You can change the color of your chat:',
        pickerTitle: 'Use this selector to find a more unique color:',
        premiumMembers: 'Premium members have access to multiple font colors.',
        premiumMembers250RP:
            'When you accumulate 250 Reward Points, unlimited chat color options will be available.',
        preview: 'Preview',
    },
    darkMode: {
        title: 'Dark Mode',
    },
    displayType: {
        title: 'Display Type',
        avatar: 'Avatar',
        details: 'Details',
        preview: 'Preview',
        textList: 'Text List',
        twoColumns: '2 Columns',
    },
    extraOptions: {
        dialogText:
            'To disable floating previews for all models, please confirm below. You can reactivate it in the Settings menu from the Home Screen.',
        dialogTitle: 'Hide Floating Previews',
        floatingPlayer: 'Enable Floating Previews',
        title: 'Extra Options',
    },
    previewAnimationRate: {
        title: 'Speed',
        off: 'Off',
        slowest: 'Slowest',
        slow: 'Slow',
        medium: 'Medium',
        fast: 'Fast',
    },
    gridDensity: {
        title: 'Display Size',
    },
    regions: {
        title: 'Regions',
        showAll: 'Toggle All',
        showOnly: 'Only',
        only: 'ONLY',
    },
    pinToTop: {
        title: 'Pin to Top',
        priorWinnersTooltip: 'Models that finished top 3 Miss MFC in any month',
        friends: 'Friends',
        bookmarks: 'Bookmarks',
        modelsYouMayLike: 'Models You May Like',
        popular: 'Most Popular',
        trending: 'Trending',
        recentlyVisited: 'Recently Visited',
        missMFC: 'Top Miss MFC Ranks',
        newModels: 'New Models',
        modelsWithNotes: 'Models with Notes',
        groupShows: 'Group Shows',
        privateShows: 'Private Shows',
        customizedPinnedModelsTitle: 'Customize Pinned Models',
        customizedPinnedModelsTooltip:
            'Some settings may take up to 60 seconds to be reflected on the home screen.',
        missMFCShort: 'Miss MFC',
    },
    groupBy: {
        title: 'Group By',
        description:
            'Display models in public chat before models in token shows',
        none: 'None',
        state: 'Public Chat; Token and Club Shows',
    },
    show: {
        title: 'Show',
        all: 'All Models',
        new: 'New Models',
        public: 'Models in Public Chat',
        friendsNew: 'Friends & New Models',
        friendsBookmarks: 'Friends & Bookmarks',
        friends: 'Only Friends',
    },
    sort: {
        title: 'Sort By',
        rating: 'CamScore',
        popular: 'Popular Rooms',
        alphabetical: 'Alphabetical',
        newestLogin: 'Newest Logged On',
        creationDate: 'Newest Signed Up',
        random: 'Random',
    },
    pushNotifications: {
        title: 'Push Notifications',
        typesTitle: 'Model Broadcasting Notifications',
        friends: 'Friends',
        bookmarks: 'Bookmarks',
        bookmarkedFriends: 'Only Bookmarked Friends',
        pmTitle: 'Private Messages',
        pm: 'Private Messages',
    },
    messagePrivacy: {
        title: 'Accept private messages from',
    },
    inlinePM: {
        title: 'Display private messages in chat room',
        description:
            'Private messages you send and receive will be displayed alongside chat room text. Other users do not see this chat.',
        onlyChatCommand: 'Only when using the /w or /pm chat command',
        onlyRoomModel: 'Only from the model',
        all: 'All PMs',
    },
    inChatQuickbuy: {
        title: 'Show QuickBuy menu in chat when token balance is depleted',
        yes: 'Yes',
        no: 'No',
    },
    tokenPrivacy: {
        title: 'Allow models to see my token balance',
        description:
            "Token approximations will show: 'Low' (1-199 tokens), 'Medium' (200-899 tokens), or 'High' (900+ tokens) instead of the actual token amount.",
        no: 'No',
        approximation: 'Approximation (Low/Medium/High)',
        yes: 'Yes',
    },
    pointsPrivacy: {
        title: 'Allow models to see my Reward Points',
        no: 'No',
        approximation: 'Approximation (Low/Medium/High)',
        yes: 'Yes',
    },
    truePrivate: {
        title: 'TruePrivate',
        description:
            'Prohibit other members from having the option to spy on your private shows. A normal private show costs 60 tokens per minute, but with TruePrivate the cost is 80 tokens per minute.',
        disabled: 'Disabled',
        enabled: 'Enabled',
    },
    privateGallery: {
        title: 'Allow my private sessions to be included in the Private Gallery',
        excluded: 'No',
        included: 'Yes',
    },
    administrativeEmails: {
        title: 'Receive administrative emails (website updates, promotions, news)',
        no: 'No',
        yes: 'Yes',
    },
    purchaseConfirmationEmails: {
        title: 'Receive token purchase confirmation emails',
        no: 'No',
        yes: 'Yes',
    },
    accountSettings: {
        lookingFor: 'Looking for',
        accountSettings: 'account settings',
    },
    reset: {
        label: 'Reset to Defaults',
    },
}
